// assets/label-left-panel-loader.js

function initLabelLeftPanelLoader() {
  const apiKey        = 'AIzaSyBJBZvhAc_or-GJCdEsGxzgV9lx3oSKhI0';
  const doorDown      = document.getElementById('DoorDownLeft');
  const doorUp        = document.getElementById('DoorUpLeft');
  const cellContainer = document.getElementById('CellsContainerLeft');
  const areaRect      = document.getElementById('CellsAreaRect');

  if (!doorDown || !doorUp || !cellContainer || !areaRect) {
    return;
  }

  const cols = 3;
  const gap  = 10;

  const areaX = parseFloat(areaRect.getAttribute('x'));
  const areaY = parseFloat(areaRect.getAttribute('y'));
  const areaW = parseFloat(areaRect.getAttribute('width'));
  const cellW = (areaW - (cols - 1) * gap) / cols;
  const cellH = cellW;

  function delay(ms) {
    return new Promise(res => setTimeout(res, ms));
  }

  async function fetchThumbnails(folderId) {
    const url = [
      'https://www.googleapis.com/drive/v3/files',
      `?q='${encodeURIComponent(folderId)}'+in+parents`,
      '&pageSize=1000',
      `&key=${encodeURIComponent(apiKey)}`,
      '&fields=files(id,mimeType)'
    ].join('');
    const res  = await fetch(url);
    const json = await res.json();
    if (!res.ok || !json.files) return [];
    return json.files.map(f => ({
      thumbUrl: f.mimeType === 'image/svg+xml'
        ? `https://drive.google.com/uc?export=download&id=${f.id}`
        : `https://drive.google.com/thumbnail?id=${f.id}&sz=w300`
    }));
  }

  document.querySelectorAll('svg.choosebutton').forEach(btn => {
    btn.addEventListener('click', async () => {
      const folderId = btn.dataset.folderId;
      if (!folderId) return;

      doorDown.classList.remove('active');
      doorUp.classList.remove('active');

      const thumbsPromise = fetchThumbnails(folderId);

      await delay(800);

      cellContainer.innerHTML = '';

      const thumbs = await thumbsPromise;

      const loadPromises = thumbs.map((img, i) => {
        const col = i % cols;
        const row = Math.floor(i / cols);
        const x   = areaX + col * (cellW + gap);
        const y   = areaY + row * (cellH + gap);

        const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        g.setAttribute('id', `CellLeft${i}`);
        g.dataset.url = img.thumbUrl;

        const iw = cellW * 0.65;
        const ih = cellH * 0.65;
        const ix = x + (cellW - iw) / 2;
        const iy = y + (cellH - ih) / 2;
        const imgEl = document.createElementNS('http://www.w3.org/2000/svg','image');
        imgEl.setAttribute('class', 'dynamic');
        imgEl.setAttributeNS('http://www.w3.org/1999/xlink','href', img.thumbUrl);
        imgEl.setAttribute('x', ix);
        imgEl.setAttribute('y', iy);
        imgEl.setAttribute('width', iw);
        imgEl.setAttribute('height', ih);
        const loadPromise = new Promise(res => {
          imgEl.addEventListener('load',  res);
          imgEl.addEventListener('error', res);
        });
        g.appendChild(imgEl);

        const frameScale = cellW / 1024;
        const useEl = document.createElementNS('http://www.w3.org/2000/svg','use');
        useEl.setAttributeNS('http://www.w3.org/1999/xlink','href', '#imgHolderLeft');
        useEl.setAttribute('transform', `translate(${x} ${y}) scale(${frameScale})`);
        g.appendChild(useEl);

        const padding = 32;
        const borderX = x + padding;
        const borderY = y + padding;
        const borderW = cellW - padding * 2;
        const borderH = cellH - padding * 2;
        const border = document.createElementNS('http://www.w3.org/2000/svg','rect');
        border.setAttribute('class', 'cell-border');
        border.setAttribute('x', borderX);
        border.setAttribute('y', borderY);
        border.setAttribute('width', borderW);
        border.setAttribute('height', borderH);
        border.setAttribute('rx', padding / 2);
        border.setAttribute('ry', padding / 2);
        border.setAttribute('fill', 'none');
        border.setAttribute('stroke', 'transparent');
        border.setAttribute('stroke-width', '2');
        Object.assign(border.style, {
          transformBox:       'fill-box',
          WebkitTransformBox: 'fill-box',
          transformOrigin:    '50% 50%',
          transition:         'stroke 0.3s ease, transform 0.3s ease, filter 0.3s ease',
          pointerEvents:      'none'
        });
        g.appendChild(border);

        cellContainer.appendChild(g);
        return loadPromise;
      });

      await Promise.all(loadPromises);

      doorDown.classList.add('active');
      doorUp.classList.add('active');
    }, { passive: true });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLabelLeftPanelLoader, { once: true });
} else {
  initLabelLeftPanelLoader();
}
